export default (str) => {

  const replaceArray = {
    'a': /ã|à|á|å|â/g,
    'e': /è|é|ê|ẽ|ë/g,
    'i': /ì|í|î/g,
    'o': /ò|ó|ô|ø/g,
    'u': /ù|ú|ů|û/g,
    'c': /ç/g,
    'n': /ñ/g,
    'ae': /ä|æ/g,
    'oe': /ö/g,
    'ue': /ü/g,
    'Ae': /Ä/g,
    'Ue': /Ü/g,
    'Oe': /Ö/g,
    'ss': /ß/g,
    'and': /&/g
  };

  str = str.toLowerCase();

  Object.keys(replaceArray).map(function(key){
    str = str.replace(replaceArray[key], key);
  });

  return str;
}
